module.exports = __webpack_public_path__ + "img/logo.05c6b190.jpg";